import styled from "styled-components";
import Icon from "~/components/shared/Icon";
import FriendlyTime from "~/components/shared/FriendlyTime";
import BuildNumber from "~/components/analytics/shared/Metadata/BuildNumber";
import { TestPlanProps } from "~/components/analytics/shared/type";
import TestPlansDropdown from "~/components/analytics/shared/Metadata/TestPlansDropdown";
import CommitSha from "~/components/analytics/shared/Metadata/CommitSha";
import Branch from "~/components/analytics/shared/Metadata/Branch";

type MetadataRowProps = {
  buildNumber: string | null | undefined;
  buildUrl: string | null | undefined;
  commitSha?: string | null | undefined;
  branch: string | null | undefined;
  createdAt: string;
  testPlans?: TestPlanProps[];
  repoUrl?: string | undefined | null;
  linkToBranchTag?: boolean;
};

export const Separator = () => <span>&middot;</span>;

const MetadataRow = ({
  buildNumber,
  buildUrl,
  commitSha,
  branch,
  createdAt,
  testPlans,
  repoUrl,
  linkToBranchTag,
}: MetadataRowProps) => (
  <div className="flex max-w-full flex-wrap items-center gap-x-2">
    {(buildNumber || buildUrl) && (
      <>
        <span data-testid="build-number">
          <BuildNumber number={buildNumber} url={buildUrl} />
        </span>

        <Separator />
      </>
    )}

    {(branch || commitSha) && (
      <>
        <span className="flex flex-wrap items-center gap-x-0.5 truncate">
          {branch && <Branch branch={branch} linkToBranchTag={linkToBranchTag} />}

          {branch && commitSha && (
            <Icon icon="custom/outline/20x/slash" style={{ height: 14, width: 14 }} />
          )}

          {commitSha && (
            <span data-testid="commit-sha">
              <CommitSha commitSha={commitSha} repoUrl={repoUrl} />
            </span>
          )}
        </span>

        <Separator />
      </>
    )}

    {testPlans && testPlans.length > 0 && (
      <>
        <TestPlansDropdown testPlans={testPlans} />

        <Separator />
      </>
    )}

    <FriendlyTime value={createdAt} />
  </div>
);

export default MetadataRow;
